export default function Settings() {
    return (
        <div className="flex flex-grow justify-center">
            <div className="h-1/2 flex items-center text-xl">
                <h1>Settings</h1>
            </div>
        </div>
    );
}
